import createSimpleReducers from '../Shared/ducks/createSimpleReducers'

export const ducks = createSimpleReducers('Medication')
